import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { getSchedule } from '../../ducks/selector';
import EditOrderModal from './edit-order-modal';

const mapStateToProps = state => ({
  schedule: getSchedule(state)
});

export default compose(connect(mapStateToProps))(EditOrderModal);
